



import ReportWrapper from '@/modules/report_server/infra/ReportWrapper.vue';
import {FacturaeProvider} from '@/modules/facturae/infra/pdf_view/FacturaeGenerator';
import {ApiInvoiceableRepository} from '@/modules/facturae/infra/ApiInvoiceableRepository'
import { ApiConfigurationRepository } from '../ApiConfigurationRepository';
import { mapGetters } from 'vuex';

export default{
    name: "report-invoice",
    components: {
        ReportWrapper,
    },
    // props: {
    //     invoiceable_id:{
    //         type: [Number, String],
    //         required: false,
    //         default: null
    //     },
    // },

    data() {
        return {
            invoiceable: null,
            configuration: null,
            rectificative_e_invoice: null,
            contentProvider: null,
            invoiceable_id:null,
            productConfiguration: null,
        };
    },
    created() {
        this.invoiceable_id = sessionStorage.getItem('reportInvoiceID');
        this.fetchInvoice();
    },
    methods: {
        async fetchInvoice() {
            const urlParams = new URLSearchParams(window.location.search);
            let some_uuid =  urlParams.get('uuid');
            try {
                let e_invoice_repo = new ApiInvoiceableRepository()
                let config_repo = new ApiConfigurationRepository()
                let pdf_info
                if (some_uuid){
                    pdf_info = await e_invoice_repo.get_pdf_info(some_uuid)
                }else{
                    pdf_info = await e_invoice_repo.get_pdf_info_by_id(this.invoiceable_id)
                }

                this.invoiceable = pdf_info['invoiceable']
                this.rectificative_e_invoice = pdf_info['rectificative_e_invoice']
                this.configuration = pdf_info['personalization']? config_repo.api_to_domain(pdf_info['personalization']): null
                this.productConfiguration = pdf_info['product_configuration']? pdf_info['product_configuration']: null

                // Configure i18n locale before creating the content provider
                const pdfLanguage = this.invoiceable?.customer?.pdf_language || 'es';
                if (pdfLanguage && pdfLanguage !== this.$i18n.locale && this.got_feature('feature_pdf_language')) {
                    this.$i18n.locale = pdfLanguage;
                } else if (!this.got_feature('feature_pdf_language')) {
                    this.$i18n.locale = 'es';
                }

                this.contentProvider = new FacturaeProvider(this.invoiceable, this.configuration, this.rectificative_e_invoice, this.productConfiguration);
            } catch (error) {
                console.error('Error fetching invoice:', error);
            }
        }
    },
    computed: {
        ...mapGetters(['got_feature']),
    }
};
